import React, { Fragment, useEffect, useMemo, useState } from "react";
import ProductItem from "../ProductItem";
import { getProducts } from "../../service/api";
import { justArray } from "../../helpers/array";
import { addSearchKeyword, searchKeywordChanges } from "../../states/search.mjs";
import { startLoading, stopLoading } from "../../states/progress.mjs";
import { toast } from "react-toastify";
import { Text } from "../Text";
import { firstLetterUpper } from "../../helpers/sentence";
import { Button } from "../Button";
import { DropdownIcon } from "../../assets/icons/dropdown-icon";

function formatNumber(number) {
  return `${number}`.trim().replace(/\B(?=(\d{3})+(?!\d))/ig, ",");
}

/**
 *
 * @param array
 * @param chunkSize
 * @return {*[]}
 */
function chunkArray(array, chunkSize) {
  const chunks = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize));
  }
  return chunks;
}

function FilterSection(
  { options = [], onOptions = () => null, initOptions = [], title }
) {
  const [isShowing, setIsShowing] = useState(true);
  const [selected, setSelected] = useState(initOptions);
  const [expanded, setExpanded] = useState([]);

  // useEffect(() => {
  //   console.log(options);
  // },[options])

  useEffect(() => {
    // console.log(selected);
    onOptions(isShowing ? justArray(selected) : []);
  }, [onOptions, selected, isShowing]);

  // function onSingleItemClick(name, value) {
  //   const exist = selected.filter(x => x?.name === name).length;
  //   if (exist > 0) {
  //     setSelected(selected.filter(y => y?.name !== name));
  //   } else {
  //     setSelected([...selected, { name, value }]);
  //   }
  // }

  function onMultipleItemClick(name,value) {
    // const isSelected = selected.filter(x=>!x?.value?.includes(name)).length;
    // if(isSelected){
    //
    // }
    const exist = expanded.filter(x => x?.name === name).length;
    if (exist > 0) {
      setSelected(selected.filter(x=>!x?.value?.includes(name)))
      setExpanded(expanded.filter(y => y?.name !== name));
    } else {
      setExpanded([...expanded, { name, value }]);
    }
  }

  return (
    <div className="flex flex-col w-full">
      {/*<div className="flex flex-nowrap flex-row mb-2">*/}
      {/*  <Text className="text font-normal">{title}</Text>*/}
      {/*  <span className="flex-grow" />*/}
      {/*  <div onClick={event => {*/}
      {/*    setIsShowing(!isShowing);*/}
      {/*  }} className="cursor-pointer">*/}
      {/*    {isShowing ? <Text className="text-sm text-indigo-600">HIDE</Text> :*/}
      {/*      <Text className="text-sm text-indigo-600">SHOW</Text>}*/}
      {/*  </div>*/}
      {/*</div>*/}

      {isShowing && justArray(options).map(({ name, value, children }, index) => {
        // console.log(children);
        return (
          <Fragment key={name + "_" + index}>
            <div key={name}
                 className={children?.length > 0
                   ? "flex cursor-pointer py-1 rounded items-start flex-col my-0"
                   : "flex cursor-pointer hover:bg-gray-300 p-1 rounded items-center flex-row flex-nowrap my-1"}
            >
              {
                !(children?.length > 0) &&
                <div className="w-[25px] h-[25px] border-2 border-black-900 rounded flex justify-center items-center">
                  {selected.filter(x => x?.name === name).length > 0 &&
                    <div className="w-[15px] h-[15px] bg-black-900 rounded" />}
                </div>
              }
              <div onClick={ () => onMultipleItemClick(name)} className={"flex-row flex w-full hover:bg-gray-300 py-1"}>
                <Text
                  className={children?.length > 0 ? "flex-grow ml-0 mr-4" : "flex-grow ml-4 mr-4"}>
                  {firstLetterUpper(name)}
                </Text>
                {
                  (children?.length > 0) &&
                  <div className="">
                    {expanded.filter(x => {
                      return x?.name === name;
                    }).length > 0 ? <div className="h-[19px] w-[48px] rotate-div">
                        <DropdownIcon />
                      </div> :
                      <div className="h-[19px] w-[48px]">
                        <DropdownIcon />
                      </div>
                    }
                    {/*{expanded === name &&*/}
                    {/*  <div className="w-[15px] h-[15px] bg-black-900 rounded" />}*/}
                    {/*{expanded !== name &&*/}
                    {/*  <div className="w-[15px] h-[15px] bg-black-900 rounded" />}*/}
                  </div>
                }
              </div>
              {
                (children?.length > 0 && expanded.filter(x => {
                  return x?.name === name;
                }).length > 0) && <div className="ml-2">
                  {
                    children?.map((item, index) => {
                      return (
                        <Fragment key={(item?.name ?? "") + "_" + index}>
                          <div onClick={() => {
                            const exist = selected.filter(x => x?.name === item.name).length;
                            if (exist > 0) {
                              setSelected(selected.filter(y => y?.name !== item.name));
                            } else {
                              setSelected([...selected, { name: item.name, value: item.value }]);
                            }
                          }} key={item?.name}
                               className="flex cursor-pointer hover:bg-gray-300 p-1 rounded items-center flex-row flex-nowrap my-1">
                            <div
                              className="w-[25px] h-[25px] border-2 border-black-900 rounded flex justify-center items-center">
                              {selected.filter(x => {
                                  return x?.name === item?.name;
                                }).length > 0 &&
                                <div className="w-[15px] h-[15px] bg-black-900 rounded" />}
                            </div>
                            <Text className="flex-grow ml-4 mr-4">{firstLetterUpper(item?.name)}</Text>
                          </div>
                        </Fragment>
                      );
                    })
                  }
                </div>
              }
            </div>
            {/*<div className="h-[1px] w-full bg-gray-300 my-3" />*/}
          </Fragment>
        );
      })}
    </div>
  );
}

export function MoreProducts({ onAddToBasket, onSelect, actionText }) {
  const [products, setProducts] = React.useState([]);
  const [rawProducts, setRawProducts] = React.useState([]);
  const [cFilter, setCFilter] = React.useState([]);
  const [pFilter, setPFilter] = React.useState([]);
  // const [sFilter, setSFilter] = React.useState([]);
  const [category, _] = React.useState(() => new URLSearchParams(window.location.search).get("category"));

  // const transformArray = useMemo(()=>{
  //   return (array) => {
  //     return array;
  //   };
  // },[]);

  const categoriesFilter = useMemo(() => {
    const b = Object.values(
      justArray(rawProducts)
        .map(x => ({
          name: x?.category,
          value: x?.category
        }))
        .flatMap(item => {
          const names = item.name.split(",");
          const values = item.value.split(",");
          return names.map((name, index) => ({
            name: name.trim(),
            value: values[index].trim()
          }));
        })
        .reduce((a, b) => ({ ...a, [b?.name]: b }), {})
    ).map(item => {
      const chunk = item.name.split("-");
      const parent = chunk.shift();
      const child = chunk.join("-");
      return {
        name: parent.trim(),
        value: parent.trim(),
        children: child ? [{
          name: child.trim(),
          value: item.value.trim()
        }] : []
      };
    }).reduce((a, b) => ({
      ...a,
      [b?.name]: { ...b, children: [...(b?.children ?? []), ...(a[b?.name]?.children ?? [])] }
    }), {});
    // console.log(Object.values(b).map(x=>{
    //   return {
    //     ...x,
    //     children: x?.children?.length>0?x?.children:[{value: x?.value, name: x?.name}]
    //   }
    // }));
    return Object.values(b).map(x=>{
      return {
        ...x,
        children: x?.children?.length>0?x?.children:[{value: x?.value, name: x?.name}]
      }
    });
  }, [rawProducts]);

  // const suppliersFilter = useMemo(() => {
  //   const onMap = x => ({ name: x?.supplier, value: x?.supplier });
  //   const onReduce = (a, b) => ({ ...a, [b?.name]: b });
  //   const onCFilter = x => cFilter.length > 0 ? cFilter.map(x => x.value).reduce((a, b) => (x.category.includes(b)) || a, false) : true;
  //   return Object.values(
  //     justArray(rawProducts)
  //       .filter(onCFilter)
  //       .map(onMap)
  //       .reduce(onReduce, {})
  //   );
  // }, [rawProducts, cFilter]);

  const pricesFilter = useMemo(() => {
    const onMap = x => ({ name: x?.retailPrice, value: x?.retailPrice });
    const onReduce = (a, b) => ({ ...a, [b?.name]: b });
    const onCFilter = x => cFilter.length > 0 ? cFilter.map(x => x.value).reduce((a, b) => {
      // console.log(x.category.includes(b),x.category,b);
      return (x.category.includes(b)) || a;
    }, false) : true;

    const data = Object.values(
      justArray(rawProducts)
        .filter(onCFilter)
        .map(onMap)
        .reduce(onReduce, {})
    );
    return chunkArray(data, 5).map(chunk => {
      const minName = formatNumber([...chunk].shift()?.name);
      const maxName = formatNumber([...chunk].pop()?.name ?? minName);
      const min = [...chunk].shift()?.value ?? 0;
      const max = [...chunk].pop()?.value ?? min;
      return {
        name: `${minName} - ${maxName}`,
        value: { min, max }
      };
    });
  }, [rawProducts, cFilter]);

  useEffect(() => {
    // setCFilter([{ name: category, value: category }]);
    addSearchKeyword(category ?? "");
    callApi();
  }, [category]);

  const filteredProducts = useMemo(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
    return rawProducts.filter(x => {
      const cb = cFilter.length > 0 ? cFilter.map(x => x.value).reduce((a, b) => (x.category.includes(b)) || a, false) : true;
      const pb = pFilter.length > 0 ? pFilter.map(x => x.value).reduce((a, b) => (x.retailPrice >= b.min && x.retailPrice <= b.max) || a, false) : true;
      // const sb = sFilter.length > 0 ? sFilter.map(x => x.value).reduce((a, b) => (x.supplier === b) || a, false) : true;
      return cb && pb /* && sb*/;
    });
  }, [cFilter, pFilter, rawProducts]);

  useEffect(() => {
    setProducts(filteredProducts);
  }, [filteredProducts]);

  useEffect(() => {
    const subscription = searchKeywordChanges((keyword) => {
      const data = justArray(filteredProducts)
        .filter(x => JSON.stringify(x).toLowerCase().includes(`${keyword}`.toLowerCase().trim()));
      setProducts(data);
    });
    return () => subscription.unsubscribe();
  }, [filteredProducts]);

  function callApi() {
    const req = {
      path: {
        pid: "c6d12f0c-7e49-449b-b5e4-98713408de66",
        aid: "99b487f4-04d6-451d-b977-dca884d4f074"
      }
    };
    startLoading();
    getProducts(req).then((res) => {
      setRawProducts(res?.data);
    }).catch((err) => {
      console.error(err);
      toast.error(err);
    }).finally(() => {
      stopLoading();
    });
  }

  return (
    <div className="flex-row flex w-full" style={{ backgroundColor: "#E8E8E8" }}>
      <div className="w-[300px] p-5">
        <Text className="text-lg font-bold">Filter by</Text>
        <div className="h-[1px] w-full bg-gray-300 my-3" />
        <FilterSection
          title={"Category"}
          initOptions={category !== "" && category !== null && category !== undefined ? [{
            name: category,
            value: category
          }] : undefined}
          onOptions={setCFilter}
          initSelected={[]} options={categoriesFilter} />
        <div className="h-[1px] w-full bg-gray-300 my-3" />
        <FilterSection
          title={"Prices ( TZS )"}
          onOptions={setPFilter}
          initSelected={[]} options={pricesFilter} />
        <div className="h-[1px] w-full bg-gray-300 my-3" />
        {/*<FilterSection*/}
        {/*  title={"Supplier"}*/}
        {/*  onOptions={setSFilter}*/}
        {/*  initSelected={[]} options={suppliersFilter} />*/}
        {/*<div className="h-[1px] w-full bg-gray-300 my-3" />*/}
      </div>
      <div className="flex flex-col md:gap-10 gap-44 items-center mt-[27px] w-full px-8 md:px-1 pb-5">
        <div className="flex flex-col items-center justify-start mx-auto md:px-5 w-full">
          <div
            className="md:gap-5 gap-[21px] grid sm:grid-cols-1 md:grid-cols-2 grid-cols-3 justify-center min-h-[auto] w-full">
            {products?.map((productsElement, index) => {
              return (
                <React.Fragment key={`products1Element${productsElement?.id ?? index}`}>
                  <ProductItem
                    onAddToBasket={() => onAddToBasket({ ...productsElement })}
                    onSelect={() => onSelect({ ...productsElement })}
                    actionText={"Add to basket" ?? "View more"}
                    image={productsElement?.images[0]}
                    name={productsElement?.product}
                    description={productsElement?.description?.split("--")[0]}
                    amount={productsElement?.retailPrice}
                    className="flex flex-1 flex-col items-start justify-start w-full" />
                </React.Fragment>
              );
            })}
          </div>
        </div>
        {
          justArray(products).length === 0 && <>
            <div className="w-[60%] mx-auto">
              <div className="p-5 flex justify-center items-center flex-col">
                {/*<EmptySearchIcon className="w-[100px] h-[100px]" />*/}
                <Text>Sorry no products to show. If you apply filter you can clear
                  or update filter. If you apply search you can update your search keyword</Text>
                <div className="mt-4 mb-4"></div>
                <Button>

                </Button>
              </div>
            </div>
          </>
        }
      </div>
    </div>
  );
}